import { useEffect } from 'react';
import { useAuth, useScopes } from '@discovr/common';
import { identifyClarityUser, setClarityTags } from './clarity';

/**
 * Ties the authenticated user into Clarity once auth + scopes resolve: links the
 * session to the Firebase uid (hashed by Clarity) and tags it with role + brandId
 * so recordings are filterable by segment. No-ops when logged out or when Clarity
 * isn't initialized (the wrapper guards that). Re-runs when uid/scopes change.
 * Mount once, inside the providers (AuthProvider + QueryClientProvider).
 *
 * Tags are best-effort: scopes load asynchronously after auth, so the effect
 * re-runs once role/brandId resolve and the tags are applied then. Absent values
 * (admins have no brandId; a still-loading or failed scopes query) are simply
 * skipped — the recording and identify still apply.
 */
export function useClarityIdentity(): void {
  const { user } = useAuth();
  const { role, brandId } = useScopes();
  const uid = user?.uid;

  useEffect(() => {
    if (!uid) return;
    identifyClarityUser({ uid });
    setClarityTags({ role, brandId });
  }, [uid, role, brandId]);
}
